import React from 'react';
import { WebsiteDesignProps } from './types';
import { Newspaper, Calendar, User } from 'lucide-react';
import { Button } from "@/components/ui/button";

const OldNewspaper: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Daily Scholar";

    return (
        <div className="bg-[#f0ece6] text-[#1a1a1a] min-h-screen font-serif selection:bg-[#1a1a1a] selection:text-white">
            {/* Paper Texture */}
            <div className="fixed inset-0 pointer-events-none opacity-40 mix-blend-multiply" style={{backgroundImage: 'url("https://www.transparenttextures.com/patterns/cream-paper.png")'}}></div>

            <header className="pt-8 pb-4 px-8 border-b-4 border-double border-black bg-[#f0ece6] relative z-10 text-center">
                <div className="flex justify-between items-end border-b border-black pb-2 mb-2 text-xs uppercase font-sans font-bold tracking-widest">
                    <span>Vol. MCCL</span>
                    <span>Knowledge for All</span>
                    <span>10 Cents</span>
                </div>
                <h1 className="text-5xl md:text-8xl font-black uppercase tracking-tight font-serif mb-4">
                    {schoolName}
                </h1>
                <div className="flex justify-center gap-8 text-xs font-sans font-bold uppercase border-t border-black pt-2">
                    <a href="#" className="hover:underline">Local News</a>
                    <a href="#" className="hover:underline">World</a>
                    <a href="#" className="hover:underline">Education</a>
                    <a href="#" className="hover:underline">Sports</a>
                    <a href="#" className="hover:underline">Classifieds</a>
                </div>
            </header>

            <main className="container mx-auto px-8 py-8 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                     {/* Lead Story */}
                     <div className="col-span-12 md:col-span-8 border-r border-black pr-8">
                         <h2 className="text-4xl md:text-6xl font-bold leading-none mb-4">
                             EXCELLENCE ACHIEVED IN RECORD TIME
                         </h2>
                         <div className="flex gap-4 text-xs font-sans text-gray-600 mb-6 font-bold uppercase">
                             <span className="flex items-center gap-1"><User size={12} /> By The Headmaster</span>
                             <span className="flex items-center gap-1"><Calendar size={12} /> January 24, 2026</span>
                         </div>
                         
                         <div className="float-left w-1/2 mr-6 mb-4 border border-black p-1 bg-white">
                             <img src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=2070&auto=format&fit=crop" className="w-full grayscale contrast-125" alt="News" />
                             <div className="text-[10px] font-sans mt-1 text-gray-500 uppercase">Fig 1. Students celebrating victory above.</div>
                         </div>
                         
                         <p className="text-lg mb-4 text-justify first-letter:text-5xl first-letter:font-bold first-letter:float-left first-letter:mr-2">
                             Extra! Extra! Read all about it. Our institution has once again shattered expectations, delivering a curriculum so robust that scholars from across the globe are clamoring for a seat.
                         </p>
                         <p className="text-lg mb-4 text-justify">
                             Witnesses describe the learning environment as "electricity in the air," citing the passionate faculty and state-of-the-art library facilities. "I've never seen anything like it," said one local resident.
                         </p>
                         <p className="text-lg text-justify">
                             Enrollment is opening soon, and experts predict spots will vanish faster than ink dries on the page.
                         </p>
                         
                         <div className="my-8 text-center">
                             <Button variant="outline" className="border-2 border-black text-black hover:bg-black hover:text-white rounded-none px-8 font-bold uppercase tracking-widest">
                                 Read Full Story (Apply)
                             </Button>
                         </div>
                     </div>

                     {/* Sidebar */}
                     <div className="col-span-12 md:col-span-4">
                         <div className="border-b-2 border-black pb-4 mb-8">
                             <h3 className="font-bold uppercase text-xl mb-4 border-b border-black inline-block">Weather</h3>
                             <p className="font-serif italic text-lg">Sunny with a high chance of success.</p>
                         </div>

                         <div className="bg-black text-white p-6 text-center mb-8">
                             <h3 className="font-bold uppercase text-2xl mb-2 text-white">Ad Space</h3>
                             <p className="text-sm border border-white p-2 mb-4">Your Future Could Be Here!</p>
                             <Button className="bg-white text-black w-full rounded-none font-bold uppercase hover:bg-gray-200">
                                 Inquire Within
                             </Button>
                         </div>

                         <div>
                             <h3 className="font-bold uppercase text-xl mb-4 border-b border-black inline-block">Upcoming</h3>
                             <ul className="space-y-4 font-serif">
                                 <li className="flex justify-between border-b border-gray-400 pb-2">
                                     <span>term Begins</span> 
                                     <span className="font-bold">Sept 1</span>
                                 </li>
                                 <li className="flex justify-between border-b border-gray-400 pb-2">
                                     <span>Science Fair</span> 
                                     <span className="font-bold">Oct 15</span>
                                 </li>
                             </ul>
                         </div>
                     </div>
                </div>
            </main>
        </div>
    );
};

export default OldNewspaper;
